export default "__VITE_ASSET__BtEdIFM6__"